import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Zoom, toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import LoaderContext from "../../context/LoaderContext/LoaderContext";
import { TostMessage, removeBlankKeys } from "../../components ByteCard/utils";
import { DELETE_CONFIRM } from "../../components ByteCard/constant";
import { FILE_TYPE, SORTING_ORDER } from "../../constant";
import TopLoadingBar from "../../utils/topLoadingBar";
import Breadcrumbs from "../../layout/breadcrumb";
import {
  Add_PlanMaster_List,
  Delete_PlanMaster_List,
  Edit_PlanMaster_List,
  PlanMaster_Enable_Desable,
  PlanMaster_List,
} from "../../api/PlanMaster Api/PlanMasterApi";
import PlanMasterContext from "../../context/PlanMasterContext/PlanMasterContext";
import PlanMasterItem from "./PlanMasterItem";
import PlanMasterAddPopup from "./PlanMasterAddPopup";

const PlanMaster = () => {
  const {
    setFormValue,
    formData,
    pageSize,
    sortOrder,
    setSortOrder,
    page,
    sortBy,
    setSortBy,
    setPageLimit,
    setRecord,
    isSwitchOn,
    setIsSwitchOn,
    addModel,
    setFormData,
    setAddModel,
    isEdit,
    setIsEdit,
    id,
    setId,
    progress,
    setProgress,
    setIsMonth,
  } = useContext(PlanMasterContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const { tabelAnimation, setTableAnimation } = useContext(LoaderContext);
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  const getPlanMasterList = async (desabledStatusLoader) => {
    if (
      sortOrder === "ASC" ||
      sortOrder === "DSC" ||
      desabledStatusLoader === false
    ) {
    } else {
      setTableAnimation(!tabelAnimation);
    }
    try {
      let paramObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy,
      };
      const { data } = await PlanMaster_List(paramObj);

      if (data.status === 200) {
        setFormValue(data.payload.data);
        setPageLimit(data.payload.pageLimit);
        setRecord(data.pager.totalRecords);

        setTableAnimation(false);
      } else {
      }
    } catch (error) {
      setTableAnimation(false);
    }
  };

  useEffect(() => {
    getPlanMasterList();
  }, [page, pageSize, sortBy, sortOrder]);

  /**
   * Enable and Disable Plan master
   */
  const switch_onChange_handle = async (planMasterId, isActive) => {
    let formData = {
      planMasterId: planMasterId,
      isActive: isActive ? false : true,
    };
    try {
      const { data } = await PlanMaster_Enable_Desable(formData, planMasterId);
      if (data.status === 200) {
        await setIsSwitchOn(!isSwitchOn);
        const desabledStatusLoader = false;
        await getPlanMasterList(desabledStatusLoader);
        isActive
          ? toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom,
            })
          : toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom,
            });
      } else {
        toast.success(data.message, {
          autoClose: 1000,
          transition: Zoom,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        autoClose: 1000,
        transition: Zoom,
      });
    }
  };

  /**
   * Sorting Plan master Table
   */
  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder(SORTING_ORDER.ASC);
    }
    if (sortOrder === SORTING_ORDER.ASC) {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder(SORTING_ORDER.DSC);
    }
    if (sortOrder === SORTING_ORDER.DSC) {
      setSortBy();
      setSortOrder("");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        if (isEdit && id >= -1) {
          const allSolutionIds = formData?.solutionIds.map((ele) => ele.value);
          let addFromData = {
            ...formData,
            solutionIds: allSolutionIds,
          };
          removeBlankKeys(addFromData);
          const { data } = await Edit_PlanMaster_List(addFromData, id);
          if (data.status === 200) {
            getPlanMasterList();
            emptyData();
            TostMessage({ message: data, type: "success" });
          }
        } else {
          const allSolutionIds = formData?.solutionIds.map((ele) => ele.value);
          let addFromData = {
            ...formData,
            solutionIds: allSolutionIds,
          };
          removeBlankKeys(addFromData);
          const { data } = await Add_PlanMaster_List(addFromData);
          if (data.status === 200) {
            getPlanMasterList();
            emptyData();
            TostMessage({ message: data, type: "success" });
          }
        }
      } catch (error) {
        TostMessage({ message: error, type: "error" });
        setLoaderShow(false);
      }
    }
  };

  /**
   * delete Plan master
   * @param {id} planMasterId
   */
  const handleDelete = async (planMasterId) => {
    let conformation = window.confirm(DELETE_CONFIRM);
    try {
      if (conformation) {
        setLoaderShow(true);
        const { data } = await Delete_PlanMaster_List(planMasterId);
        if (data.status === 200) {
          getPlanMasterList();
          TostMessage({ message: data, type: "success" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };

  const emptyData = () => {
    setFormData({
      planName: "",
      amount: "",
      solutionIds: [],
      type: "",
      validityMonth: "",
      validityDay: "",
      promoCode: "",
    });
    setIsMonth(false);
    setAddModel(false);
    setIsEdit(false);
    setId("");
  };
  return (
    <Fragment>
      <Breadcrumbs parent="Plan Master" />
      <TopLoadingBar progress={progress} setProgress={setProgress} />
      {addModel && (
        <PlanMasterAddPopup
          handleSubmit={handleSubmit}
          simpleValidator={simpleValidator}
          emptyData={emptyData}
        />
      )}

      <PlanMasterItem
        sorting={sorting}
        switch_onChange_handle={switch_onChange_handle}
        handleDelete={handleDelete}
      />
    </Fragment>
  );
};

export default PlanMaster;
